import styled from "styled-components";
import CI from "@trackcode/ci";

export const LogisticCompanyMenuGrid = styled.div`
  display: flex;
  width: 840px;
  max-width: 100%;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

export const LogisticCompanyMenuGridItem = styled.div`
  min-width: 280px;
  max-width: 280px;
  padding-bottom: 6px;
`;

export const LogisticCompanyDropdownPanel = styled.div`
  width: 100%;
  max-height: ${({ $open }) => ($open ? "640px" : "0")};
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  visibility: ${({ $open }) => ($open ? "visible" : "hidden")};
  pointer-events: ${({ $open }) => ($open ? "auto" : "none")};
  overflow: hidden;
  box-sizing: border-box;
  text-align: left;
  background-image: ${({ $embedded }) =>
    $embedded ? "none" : "linear-gradient(#ffffff, #f8f8f8)"};
  box-shadow: ${({ $embedded }) =>
    $embedded ? "none" : "0 1px 4px 0 rgba(44, 44, 44, 0.4)"};
  transition: max-height 370ms ease, opacity 250ms ease;
`;

export const LogisticCompanyDropdownInner = styled.div`
  padding: ${CI.space.sm}px;
`;
